import React, { FC, useState } from "react";
import "./AddBusinessArticle.css";
import ExpandableMenu from "../ExpandableMenu/ExpandableMenu";
import ManagerRightDiv from "../ManagerRightDiv/ManagerRightDiv";

interface AddBusinessArticleProps {}

const AddBusinessArticle: FC<AddBusinessArticleProps> = () => {
  const [expandedMenu, setExpandedMenu] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string>("abarticle");
  return (
    <>
      <div className="container">
        <div className="row">
          <ExpandableMenu activeTabs={activeTab} expandedMenus={expandedMenu} />
          <ManagerRightDiv aid={1} />
        </div>
      </div>
    </>
  );
};

export default AddBusinessArticle;
